import { HttpClient } from '../interceptor';

export class ClassroomCardsManagementApi{
    // 获取教室次卡列表
    static getClassroomCardsList = () => {
        return new Promise(resolve => {
            HttpClient.post('/api/numberCardController/queryNumberCardToB', {}).then(res => {
                if(res.data.status === 200){
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    // 新增教室卡
    static insertClassroomCard = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/numberCardController/addNumberCard', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 编辑教室卡
    static updateClassroomCard = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/numberCardController/updateNumberCardToB', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }
}